import React from 'react';
import { Icon } from './Icon.js';
export const IconHouse7 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 21V11L22 10.5V9.5L12 2L2 9.5V10.5L4 11V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M9 21V16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16V21", stroke: "currentColor", strokeWidth: "2", fill: "none" }),
        React.createElement("path", { d: "M12 9H12.01", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M2 21H22", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconHouse7.js.map